import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { ServerService } from 'src/services/server.service';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CodeComponent } from './code/code.component';
import { MainMenuComponent } from './main-menu/main-menu.component';
import { SnippetsComponent } from './snippets/snippets.component';
import { SettingsComponent } from './settings/settings.component';
import { LoginComponent } from './login/login.component';
import { HttpErrorInterceptor } from 'src/services/http-interceptor';
import { SafeHtmlPipe } from './pipes/safe-html-pipe';
import { TaskTrackerItemComponent } from './task-tracker-item/task-tracker-item.component';
import { ReplacingComponent } from './replacing/replacing.component';
import { MainComponent } from './main/main.component';
import { ContextMenuComponent } from './context-menu/context-menu.component';
import { DropDownComponent } from './drop-down/drop-down.component';

@NgModule({ declarations: [
        AppComponent,
        MainMenuComponent,
        CodeComponent,
        SnippetsComponent,
        SettingsComponent,
        LoginComponent,
        SafeHtmlPipe,
        TaskTrackerItemComponent,
        ReplacingComponent,
        MainComponent,
        ContextMenuComponent,
        DropDownComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        FormsModule], providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpErrorInterceptor,
            multi: true,
        },
        ServerService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { 

  constructor(){
  }
  
}
